const getDefaultState = () => {
    return {
        language: null,
        systemLanguages: ['eng'],
    }
}

const state = getDefaultState()

const getters = {
    systemLanguage(state: any) {
        return state.language ? state.language : state.systemLanguages[0]
    },
}

const mutations = {
    systemLanguages(state: any, payload: any) {
        state.systemLanguages = payload
    },

    systemLanguage(state: any, payload: any) {
        state.language = payload
    },

    //RESET
    resetSystemLanguage(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
